import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { InputIcon } from "primereact/inputicon";
import { IconField } from "primereact/iconfield";

import { SearchIcon } from "@/components/atoms/icons";

interface SearchbarProps {
  onSearch: (query: string) => void;
  onCancel?: () => void;
  value?: string;
  placeholder?: string;
}

const Searchbar: React.FC<SearchbarProps> = ({ onSearch, onCancel, placeholder, value = "" }) => {
  const [query, setQuery] = useState(value);

  const handleSearch = () => {
    onSearch(query);
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearch();
    } else if (e.key === "Escape") {
      e.preventDefault();
      onSearch("");
      if (typeof onCancel !== "undefined") {
        onCancel();
      }
    }
  };

  return (
    <IconField iconPosition="right">
      <InputIcon>
        <SearchIcon />
      </InputIcon>
      <InputText
        autoFocus
        className="transition-width w-full min-w-[350px] duration-500 ease-in-out"
        placeholder={placeholder}
        value={query}
        variant="outlined"
        onChange={(e) => setQuery(e.target.value)}
        onKeyDown={handleKeyPress}
      />
    </IconField>
  );
};

export default Searchbar;
